export * from "ce/sagas";
import { sagas as CE_Sagas } from "ce/sagas";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { call, all, spawn, race, take } from "redux-saga/effects";
import { appsmithTelemetry } from "instrumentation";
import log from "loglevel";
import AclSagas from "./AclSagas";
import AuditLogsSagas from "ee/sagas/AuditLogsSagas";
import EnvironmentSagas from "./EnvironmentSagas";
import AISagas from "./aiSagas";
import ProvisioningSagas from "./ProvisioningSagas";
import PackagesSagas from "./packagesSagas";
import PackageInitSagas from "./packageInitSagas";
import PackageIDESagas from "./packageIDESagas";
import WorkflowInitSagas from "./workflowInitSagas";
import ModuleInstanceSaga from "./moduleInstanceSagas";
import ModuleSagas from "./moduleSagas";
import WorkflowsSagas from "./workflowsSagas";
import WorkflowsActionSagas from "./workflowsActionSagas";
import ModuleActionSagas from "./moduleActionSagas";
import gitPackageSagas from "git-artifact-helpers/ee/packages/sagas";
import WorkflowsHITLSagas from "./WorkflowsHITLSagas";
import uiModuleInstanceSagas from "./uiModuleInstanceSagas";
import { watchAIActionsSagas } from "./AIActionsSaga";
import AiAgentSagas from "./AiAgentSagas";
import GenerateSchemaSagas from "./GenerateSchemaSaga";
import BillingSagas from "./billingSagas";
import ChromeExtensionSagas from "./ChromeExtensionSagas";
import sshKeysSagas from "ee/sagas/sshKeysSagas";

const sagasArr = [
  ...CE_Sagas,
  AclSagas,
  watchAIActionsSagas,
  AuditLogsSagas,
  EnvironmentSagas,
  AISagas,
  ProvisioningSagas,
  PackagesSagas,
  WorkflowsSagas,
  WorkflowsActionSagas,
  WorkflowsHITLSagas,
  PackageIDESagas,
  PackageInitSagas,
  WorkflowInitSagas,
  uiModuleInstanceSagas,
  ModuleInstanceSaga,
  ModuleSagas,
  ModuleActionSagas,
  gitPackageSagas,
  AiAgentSagas,
  GenerateSchemaSagas,
  BillingSagas,
  ChromeExtensionSagas,
  sshKeysSagas,
];

// TODO: Fix this the next time the file is edited
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* rootSaga(sagasToRun = sagasArr): any {
  // This race effect ensures that we fail as soon as the first safe crash is dispatched.
  // Without this, all the subsequent safe crash failures would be shown in the toast messages as well.
  const result = yield race({
    running: all(
      sagasToRun.map((saga) =>
        spawn(function* () {
          while (true) {
            try {
              yield call(saga);
              break;
            } catch (e) {
              log.error(e);
              appsmithTelemetry.captureException(e, {
                errorName: "RootSagaError",
              });
            }
          }
        }),
      ),
    ),
    crashed: take(ReduxActionTypes.SAFE_CRASH_APPSMITH),
  });

  if (result.crashed) yield call(rootSaga);
}
